/**
 *
 */

var Sliders = (function($) {
  function initSliders() {
    // do something
  }

  function initWorkSliders() {
    new Swiper(".work-featured-project-slider", {
      slidesPerView: 1,
      spaceBetween: 40,
      loop: false,
      speed: 1200,

      pagination: {
        el: ".work-featured-project-slider-pagination",
        clickable: true
      }
    });
  }

  function initProjectSlider() {
    var contactGallerySlider = new Swiper(".project-content-slider", {
      slidesPerView: "auto",
      spaceBetween: 12,
      loop: true,
      grabCursor: true,
      freeMode: {
        enabled: true,
        momentum: true
      },
      mousewheel: {
        forceToAxis: true
      },
      speed: 800
    });
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".swiper").length) {
      return;
    }

    initSliders();
    initWorkSliders();
    initProjectSlider();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Sliders.init);
